<template>
    <div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            dynamic_url: "",
        }
    },
    async created() {
        var currentUrl = window.location.href;
        var path = window.location.pathname;
        this.$q.loading.show({
            message: "Authenticating please wait..",
        });
        if (this.$cookies.isKey("login_authentication")) {
            let encryptedText = this.$cookies.get("login_authentication");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonadoptimization/connect");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication1")) {
            let encryptedText = this.$cookies.get("login_authentication1");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication2")) {
            let encryptedText = this.$cookies.get("login_authentication2");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonadoptimization/connect");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else {
            this.$q.loading.hide();
            this.$router.push({
                name: "NotAuthenticated",
            });
            return;
        }
    },
        mounted(){
        // if (currentUrl != "http://localhost:8080/amazonadoptimization/connect/" + this.$org_encryprt.label) {
            this.$q.loading.show({
                message: "Loading your data please wait..",
            });
            localStorage.setItem('ad_connection', 'progress');
            var currentUrl = window.location.href;
            var path = window.location.pathname;
            var spapi_oauth_code = this.getStringBetween(currentUrl, '=', '&scope');
                this.org_id = localStorage.getItem('orgid');
                this.top_level_orgid = localStorage.getItem('top_level_orgid');
                console.log('this.top_level_orgid: ', this.top_level_orgid, 'this.org_id: ', this.org_id)
                let URL = this.api_url + "/amazon-ad/save_ad_token/" + spapi_oauth_code + "/" + this.top_level_orgid;
                this.$http.post(URL).then((response) => {
                    let result = response;
                    localStorage.setItem('ad_connection', 'true');
                    // this.$router.push("/home/1");
                }).catch((err) => {
                    localStorage.setItem('ad_connection', 'error');
                    this.$q.notify({
                        message: err,
                        color: "negative",
                    });
                }).finally(()=>{

                    this.$q.loading.hide();
                });
    },
    computed: {
        seller_api_URL() {
            return this.dynamic_url;
        },
    },
    methods: {
        getStringBetween(str, start, end) {
            const result = str.match(new RegExp(start + "(.*)" + end));
            return result[1];
        },
    }
}

</script>



